

















































































































import { Vue, Component } from 'vue-property-decorator'
import MarketingPoints from '@/components/MarketingPoints.vue'

@Component({
    components: {
        MarketingPoints,
    },
})
export default class PackageContentOriginal extends Vue {
    packageOriginalTitleImage =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/basicplan_title%402x.png'
    featureMusio =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/feature_2.webp'
    featureKimini =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/feature_1.webp'
}
